import PropTypes from 'prop-types'

const ArrowRight = ({ fill = '#1A1A1A' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M12.175 8.588H1C0.716667 8.588 0.479167 8.49217 0.2875 8.3005C0.0958333 8.10883 0 7.87133 0 7.588C0 7.30467 0.0958333 7.06717 0.2875 6.8755C0.479167 6.68383 0.716667 6.588 1 6.588H12.175L7.275 1.688C7.075 1.488 6.97917 1.25467 6.9875 0.988C6.99583 0.721333 7.1 0.488 7.3 0.288C7.5 0.104667 7.73333 0.00883333 8 0.0005C8.26667 -0.00783333 8.5 0.088 8.7 0.288L15.3 6.888C15.4 6.988 15.4708 7.09633 15.5125 7.213C15.5542 7.32967 15.575 7.45467 15.575 7.588C15.575 7.72133 15.5542 7.84633 15.5125 7.963C15.4708 8.07967 15.4 8.188 15.3 8.288L8.7 14.888C8.51667 15.0713 8.2875 15.163 8.0125 15.163C7.7375 15.163 7.5 15.0713 7.3 14.888C7.1 14.688 7 14.4505 7 14.1755C7 13.9005 7.1 13.663 7.3 13.463L12.175 8.588Z'
        fill={fill}
      />
    </svg>
  )
}

ArrowRight.propTypes = {
  fill: PropTypes.string,
}

export default ArrowRight
